import { ReactNode } from 'react';

import { Typography } from '@speeki/global-ui-components';
import { IconManager } from '@speeki/icons';

import { DefaultLayout } from '@components/templates/DefaultLayout/DefaultLayout.tsx';

import {
    InfoText,
    InfoWrapper,
    SuccessIconWrapper,
    SuccessTemplateWrapper,
} from './SuccessTemplate.styled';

interface SuccessTemplateProps {
    children?: ReactNode;
    texts: ReactNode[];
    title: string;
}

export const SuccessTemplate = ({
    children,
    texts,
    title,
}: SuccessTemplateProps) => {
    return (
        <DefaultLayout
            contentPadding={{
                top: 0,
            }}
        >
            <SuccessTemplateWrapper>
                <InfoWrapper>
                    <SuccessIconWrapper>
                        <IconManager icon="SvgThankYouCircle" size={89} />
                    </SuccessIconWrapper>
                    <Typography.TextH3_24_34>{title}</Typography.TextH3_24_34>
                    {texts.map((text) => (
                        <InfoText>{text}</InfoText>
                    ))}
                    {children}
                </InfoWrapper>
            </SuccessTemplateWrapper>
        </DefaultLayout>
    );
};
